/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Header code */
window.addEventListener("DOMContentLoaded", function () {
  let headerElement = document.getElementById("section-header");
  const header = document.querySelector(".Header__MainNav");
  const grandchild = header.querySelectorAll(".grandchild-link");
  const images = header.querySelectorAll(".shop-dropdown__image");
  const fallbackImage = header.querySelector(".shop-dropdown__fallback-image");
  const accordions = document.querySelectorAll(".mobile-menu__accordion");
  const mobileTrigger = document.querySelector(".mobile-menu__trigger");
  const mobileMenu = document.querySelector(".mobile-menu");
  const mobileContainer = document.querySelector(".mobile-menu__container");
  const mobileBackground = document.querySelector(".mobile-menu__background");

  grandchild.forEach(element => {
    const elementData = element.href;
    element.addEventListener("mouseover", () => {
      let useFallback = true;

      images.forEach(image => {
        const imageData = image.dataset.imageType;
        if (elementData.includes(imageData) ){
          image.classList.add("active");
          useFallback = false;
        } else {
          image.classList.remove("active");
        }
      });

      if (useFallback){
        fallbackImage.classList.add("active");
      }
    });

    // element.addEventListener("mouseleave", () => {
    //   fallbackImage.classList.add("active");
    // });
  });

  if (accordions){
    accordions.forEach(accordion => {
      const trigger = accordion.querySelector(".mobile-menu__accordion-trigger");
      const content = accordion.querySelector(".mobile-menu__accordion-content");
      const secondAccordions = content.querySelectorAll(".mobile-menu__second-accordion");

      // on accordion click
      trigger.addEventListener("click", () => {
        // deactivate all accordions
        accordions.forEach(element => {
          const elementTrigger = element.querySelector(".mobile-menu__accordion-trigger");
          const content = element.querySelector(".mobile-menu__accordion-content");

          if(trigger.dataset.index !== elementTrigger.dataset.index){
            element.classList.remove("active");
            elementTrigger.classList.remove('active');
            content.classList.remove('active');
            elementTrigger.classList.remove('is-open');
          }
        });

        // activate clicked accordion
        if (trigger.classList.contains('is-open')){
          accordion.classList.remove("active");
          trigger.classList.remove('active');
          content.classList.remove('active');
        } else {
          accordion.classList.add("active");
          trigger.classList.add('active');
          content.classList.add('active');
        }


        trigger.classList.toggle('is-open');
      });

      // secondary accordions
      secondAccordions.forEach(secondAccordion => {
        const secondTrigger = secondAccordion.querySelector(".mobile-menu__second-accordion-trigger");
        const secondContent = secondAccordion.querySelector(".mobile-menu__second-accordion-content");

        secondTrigger.addEventListener("click", () => {
          secondAccordions.forEach(grandChild => {
            const thirdTrigger = grandChild.querySelector(".mobile-menu__second-accordion-trigger");
            const content = grandChild.querySelector(".mobile-menu__second-accordion-content");

            if(secondAccordion.dataset.index !== grandChild.dataset.index){
              grandChild.classList.remove("active");
              thirdTrigger.classList.remove('active');
              content.classList.remove('active');
              grandChild.classList.remove('is-open');
            }

          });

          // activate clicked accordion
          if (secondAccordion.classList.contains('is-open')){
            secondAccordion.classList.remove("active");
            secondTrigger.classList.remove('active');
            secondContent.classList.remove('active');
          } else {
            secondAccordion.classList.add("active");
            secondTrigger.classList.add('active');
            secondContent.classList.add('active');
          }

          secondAccordion.classList.toggle('is-open');
        });
      });
    });
  }

  if (mobileTrigger){
    const open = mobileTrigger.querySelector(".mobile-menu__trigger-open");
    const close = mobileTrigger.querySelector(".mobile-menu__trigger-close");

    mobileTrigger.addEventListener("click", () => {
      mobileContainer.classList.toggle("active");
      mobileMenu.classList.toggle("active");
      open.classList.toggle("active");
      close.classList.toggle("active");
    });

    mobileBackground.addEventListener("click", () => {
      mobileContainer.classList.toggle("active");
      mobileMenu.classList.toggle("active");
      open.classList.toggle("active");
      close.classList.toggle("active");
    });
  }

  const doc = document.documentElement;
  doc.style.setProperty("--mobile-header-height", `${headerElement.offsetHeight}px`);
  doc.style.setProperty("--mobile-app-height", `${window.innerHeight}px`);


  window.addEventListener("resize", () => {
    doc.style.setProperty("--mobile-header-height", `${headerElement.offsetHeight}px`);
    doc.style.setProperty("--mobile-app-height", `${window.innerHeight}px`);
  });

  window.addEventListener("scroll", () => {
    headerElement = document.getElementById("section-header");
    doc.style.setProperty("--mobile-header-height", `${headerElement.offsetHeight}px`);
  });
});

/* Book Add To Cart */

window.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".GUUD__AddToCartButton");
  const form = document.querySelector(".product-form");


  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const formData = new FormData(e.target);
      if (formData.get("properties[_ts]")) {
        formData.set("properties[_ts]", Date.now());
      }
      addCustomAjax(formData);
    });

    for (const button of buttons) {
      button.addEventListener("click", function () {
      form.querySelector(".product-form__cart-submit").click();
      });
    }
  }
});

window.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".GUUD__AddToCartButton-comp");
  const form = document.querySelector(".product-form-comp");


  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const formData = new FormData(e.target);
      addCustomAjax(formData);
    });

    for (const button of buttons) {
      button.addEventListener("click", function () {
       form.querySelector(".product-form__cart-submit").click();
        console.log(form)
      });
    }
  }
});

/* Language Selector Open */

window.addEventListener("DOMContentLoaded", function () {
  const languageContainers = document.querySelectorAll(
    ".LanguageSelector__Container"
  );

  for (const languageContainer of languageContainers) {
    const languageButton = languageContainer.querySelector(
      ".LanguageSelector__LanguageButton"
    );

    languageButton.addEventListener("click", function () {
      languageContainer.classList.toggle("open");
      document.documentElement.classList.toggle("no-scroll");
    });

    document.onclick = function (e) {
      if (languageContainer.classList.contains("open")) {
        if (
          e.target != languageContainer &&
          e.target !=
            document.querySelector(
              ".HorizontalList__Item.HeaderIcon--Locale"
            ) &&
          e.target != languageButton &&
          !languageContainer.contains(e.target)
        ) {
          languageContainer.classList.remove("open");
          document.documentElement.classList.remove("no-scroll");
        }
      }
    };
  }
});

if (!Shopify.designMode) {
  window.addEventListener("DOMContentLoaded", function () {
    const redirectDisabled = this.localStorage.getItem("redirect-disabled");
    const selectors = document.querySelectorAll(
      ".LanguageSelector__DropdownInner--language"
    );
    // const heading = document.querySelector(".site-header-cart-side__header-title");
    // const isotext = heading.querySelector(".iso-text");
    let correctCountry = true;
    let redirectActive = true;
    let path;
    let iso;

    var requestOptions = {
      method: "GET",
    };

    fetch(
      "https://api.geoapify.com/v1/ipinfo?&apiKey=4cef62a1320c4ec991daa085c22f186f",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        iso = result.country.iso_code;
        // isotext.innerText = `${iso}`;

        selectors.forEach((selector) => {
          selector.addEventListener("click", () => {
            this.localStorage.setItem("redirect-disabled", true);
          });
        });

        if (redirectDisabled !== null) {
          redirectActive = false;
        }

        if (redirectActive) {
          // Update url to take French users to the French site
          if (iso == "FR") {
            if (window.location.pathname.includes("/en")) {
              path = window.location.pathname.replace("en", "fr-fr");
              correctCountry = false;
            } else if (!window.location.pathname.includes("fr")) {
              path = "/fr-fr" + window.location.pathname;
              correctCountry = false;
            } else if (window.location.pathname == "/fr") {
              path = "/fr-fr";
              correctCountry = false;
            } else if (window.location.pathname.includes("/fr/")) {
              path = window.location.pathname.replace("/fr/", "/fr-fr/");
              correctCountry = false;
            }
          }
          // Update url to take Netherland users to the Netherland site
          if (iso == "NL") {
            if (window.location.pathname.includes("/en-nl")) {
              path = window.location.pathname.replace("en-nl", "nl-nl");
              correctCountry = false;
            } else if (window.location.pathname.includes("/fr-nl")) {
              path = window.location.pathname.replace("fl-nl", "nl-nl");
              correctCountry = false;
            } else if (window.location.pathname.includes("/fr")) {
              path = window.location.pathname.replace("fr", "nl-nl");
              correctCountry = false;
            } else if (window.location.pathname.includes("/en")) {
              path = window.location.pathname.replace("en", "nl-nl");
              correctCountry = false;
            } else if (!window.location.pathname.includes("/nl")) {
              path = "/nl-nl" + window.location.pathname;
              correctCountry = false;
            } else if (window.location.pathname == "/nl") {
              path = "/nl-nl";
              correctCountry = false;
            } else if (window.location.pathname.includes("/nl/")) {
              path = window.location.pathname.replace("/nl/", "/nl-nl/");
              correctCountry = false;
            }
          }

          // If user is from Belgium
          if (iso == "BE") {
            // Go to English site if preferred language is Englsih
            if (
              window.navigator.language == "en" ||
              window.navigator.language.includes("en-")
            ) {
              if (window.location.pathname.includes("/fr-fr")) {
                path = window.location.pathname.replace("/fr-fr", "/en");
                correctCountry = false;
              } else if (window.location.pathname.includes("/fr")) {
                path = window.location.pathname.replace("/fr", "/en");
                correctCountry = false;
              } else if (window.location.pathname.includes("/nl-nl")) {
                path = window.location.pathname.replace("/nl-nl", "/en");
                correctCountry = false;
              }

              // Go to French site if preferred language is French
            } else if (
              window.navigator.language == "fr" ||
              window.navigator.language.includes("fr-")
            ) {
              if (window.location.pathname.includes("/en")) {
                path = window.location.pathname.replace("/en", "/fr");
                correctCountry = false;
              } else if (window.location.pathname.includes("/fr-fr")) {
                path = window.location.pathname.replace("/fr-fr", "/fr");
                correctCountry = false;
              } else if (!window.location.pathname.includes("/fr")) {
                path = "/fr" + window.location.pathname;
                correctCountry = false;
              }
            } else {
              if (window.location.pathname.includes("/en")) {
                path = window.location.pathname.replace("/en", "/");
                correctCountry = false;
              } else if (window.location.pathname.includes("/fr-fr")) {
                path = window.location.pathname.replace("/fr-fr", "/");
                correctCountry = false;
              } else if (window.location.pathname.includes("/fr")) {
                path = window.location.pathname.replace("/fr", "/");
                correctCountry = false;
              }
            }
          }

          // If user is not from France or Belgium or Netherlands
          if (iso !== "FR" && iso !== "BE" && iso !== "NL") {
            // Go to French site if preferred language is French
            if (
              window.navigator.language == "fr" ||
              window.navigator.language.includes("fr-")
            ) {
              if (window.location.pathname.includes("/en")) {
                path = window.location.pathname.replace("/en", "/fr");
                correctCountry = false;
              } else if (window.location.pathname.includes("/fr-fr")) {
                path = window.location.pathname.replace("/fr-fr", "/fr");
                correctCountry = false;
              } else if (!window.location.pathname.includes("/fr")) {
                path = "/fr" + window.location.pathname;
                correctCountry = false;
              }
              // Go to default site if preferred language is Dutch
            } else if (window.navigator.language == "nl") {
              if (window.location.pathname.includes("/en")) {
                path = window.location.pathname.replace("/en", "/");
                correctCountry = false;
              } else if (window.location.pathname.includes("/fr-fr")) {
                path = window.location.pathname.replace("/fr-fr", "/");
                correctCountry = false;
              } else if (window.location.pathname.includes("/fr")) {
                path = window.location.pathname.replace("/fr", "/");
                correctCountry = false;
              }
            } else {
              // If  if preferred language is not French or Dutch
              if (window.location.pathname.includes("/fr-fr")) {
                path = window.location.pathname.replace("/fr-fr", "/en");
                correctCountry = false;
              } else if (window.location.pathname.includes("/fr")) {
                path = window.location.pathname.replace("/fr", "/en");
                correctCountry = false;
              } else if (window.location.pathname.includes("/nl-nl")) {
                path = window.location.pathname.replace("/nl-nl", "/en");
                correctCountry = false;
              } else if (!window.location.pathname.includes("/en")) {
                path = "/en" + window.location.pathname;
                correctCountry = false;
              }
            }
          }

          if (!correctCountry) {
            const destination = "https://" + window.location.hostname + path;
            // console.log("destination", destination);
            window.location.href = destination;
          }
        }
      })
      .catch((error) => console.log("error", error));
  });
}

/* cartClose = document.querySelector('#sidebar-cart .Drawer__Close');
let cartHeader = document.querySelector('#section-header');
cartClose.addEventListener('click', function() {
  cartHeader.classList.remove('Header--transparent');
});*/

/* Footer Spacer */

window.addEventListener("DOMContentLoaded", function () {
  let footer = document.querySelector("#shopify-section-footer footer");
  let footerSpacer = document.querySelector(".footer-spacer ");

  footerSpacer.style.height = footer.offsetHeight + "px";
  window.addEventListener("resize", function () {
    if (window.innerWidth >= 1200) {
      footerSpacer.style.height = footer.offsetHeight + "px";
    }
  });
});

/*------------------------------------------------------------------
 * Gift Card Variant Selector
 *------------------------------------------------------------------ */

window.addEventListener("DOMContentLoaded", function () {
  const variantButtons = document.querySelectorAll(
    ".Gift_Cards .Variant_Option"
  );
  const variantDropDown = document.querySelector(
    ".Gift_Cards .Variant_Options"
  );
  const variantIds = document.querySelectorAll(".Gift_Cards .VariantId");

  variantButtons.forEach((e, i) => {
    e.addEventListener("click", function () {
      document
        .querySelector('.Gift_Cards .Variant_Option[selected="selected"')
        .removeAttribute("selected");
      e.setAttribute("selected", "selected");
      document
        .querySelector('input[name="id"]')
        .setAttribute("value", variantIds[i].innerText);
      document.querySelector(".add-to-bag-desktop .price").innerText =
        e.innerText;
      document.querySelector(
        ".mobile-button .price-and-quantity > small"
      ).innerText = e.innerText;
    });
  });
});

/*------------------------------------------------------------------
 * Header transparency adjustments
 *------------------------------------------------------------------ */

(function () {
  function ensureHeader() {
    if (typeof this.window.header === "undefined") {
      this.window.header = document.querySelector("#section-header");
      this.window.header.breakpoint = 1140;
      this.window.header.desktop = true;
      this.window.header.bodyElement = this.document.querySelector("body");
      this.window.header.hasAnnouncementBar =
        this.window.header.querySelector(".AnnouncementBar") !== null;
      this.window.header.hasTransparentHeaderDefault = JSON.parse(
        this.window.header.dataset["sectionSettings"]
      ).hasTransparentHeader;
    }
  }
  function fixHeaderTransparency() {
    ensureHeader();
    if (
      this.window.header.classObj.options.isSticky &&
      this.window.header.hasTransparentHeaderDefault
    ) {
      if (
        this.window.innerWidth >= this.window.header.breakpoint &&
        !this.window.header.dekstop
      ) {
        // desktop
        this.window.header.classObj.options.hasTransparentHeader = true;
        this.window.header.classObj.checkTransparentHeader();

        this.window.header.bodyElement.style.removeProperty("--header-height");
        this.window.header.bodyElement.style.removeProperty(
          "--announcement-bar-height"
        );
      } else if (
        this.window.innerWidth < this.window.header.breakpoint &&
        this.window.header.desktop
      ) {
        this.window.header.classObj.options.hasTransparentHeader = false;
        this.window.header.classList.remove("Header--transparent");

        this.window.header.bodyElement.style.setProperty(
          "--header-height",
          "0px"
        );
        this.window.header.bodyElement.style.setProperty(
          "--announcement-bar-height",
          "0px"
        );
      }
    }
  }
  addEventListener("scroll", function (event) {
    if (this.window.innerWidth > 1139){
      ensureHeader();
      if (this.window.header.hasAnnouncementBar) {
        if (this.window.scrollY < 280) {
          this.window.header.classList.remove("Header--shifted");
          this.document.getElementById("sidebar-cart").classList.remove("Header--shifted");
        } else {
          this.window.header.classList.add("Header--shifted");
          this.document.getElementById("sidebar-cart").classList.add("Header--shifted");
        }
      }
    }
  });
  addEventListener("DOMContentLoaded", function (event) {
    fixHeaderTransparency();
  });
  addEventListener("resize", function (event) {
    fixHeaderTransparency();
  });
})();

/*------------------------------------------------------------------
 * Accordion
 *------------------------------------------------------------------ */
window.addEventListener("DOMContentLoaded", function () {
  this.document
    .querySelectorAll(".accordion .accordion-header")
    .forEach((btn) => {
      btn.addEventListener("click", () => {
        const content = btn.nextElementSibling;
        if (content.style.height == "0px") {
          // open
          btn.classList.add("open");
          btn.classList.remove("close");
          content.style.height = `${
            content.querySelector(".accordion-body").clientHeight
          }px`;
          this.setTimeout(() => {
            content.style.height = "auto";
          }, 300);
        } else {
          // close
          btn.classList.add("close");
          btn.classList.remove("open");
          content.style.height = `${
            content.querySelector(".accordion-body").clientHeight
          }px`;
          this.setTimeout(() => {
            content.style.height = "0px";
          }, 1);
        }
      });
    });
});

/*------------------------------------------------------------------
 * Slideshow fix
 *------------------------------------------------------------------ */
window.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 641) {
    document
      .querySelectorAll(".Slideshow .Slideshow__Carousel")
      .forEach((slider) => {
        function deferFlkty(e, cb, tries) {
          if (e.flickityGUID) {
            cb(new Flickity(e));
          } else {
            if (tries < 201) {
              setTimeout(() => {
                deferFlkty(elem, cb, tries + 1);
              }, 50);
            }
          }
        }

        deferFlkty(
          slider,
          (flkty) => {
            var counter = 0;
            var id = setInterval(() => {
              flkty.reloadCells();

              counter++;

              if (counter == 5) {
                clearInterval(id);
              }
            }, 1000);
          },
          0
        );
      });
  }
});

function addItemToCart(variant_id, qty, selling_plan) {
  changeCustomAjax({
    id: variant_id,
    quantity: qty,
    selling_plan: selling_plan,
  });
}

function changeCustomAjax(formData) {
  fetch(`${window.routes.cartChangeUrl}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      updateCustomAjax(formData);
      refreshCustomAjax();
      openDrawerCustomAjax();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function addCustomAjax(formData) {

  
  fetch(`${window.routes.cartAddUrl}.js`, {
    method: "POST",
    body: formData,
    headers: {
      "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
    },
  })
    .then((response) => {
      updateCustomAjax(formData);
      refreshCustomAjax();
      openDrawerCustomAjax();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function updateCustomAjax(formData) {
  fetch(`${window.routes.cartUrl}/update.js`, {
    body: JSON.stringify(formData),
    method: "POST",
  });
}

function openDrawerCustomAjax() {
  document.dispatchEvent(
    new CustomEvent("product:added", { bubbles: true, detail: {} })
  );
}

function refreshCustomAjax() {
  document.dispatchEvent(
    new CustomEvent("cart:refresh", { bubbles: true, detail: {} })
  );
}

let headerMain = document.querySelector("#section-header");
let sideMenu = document.querySelector("#sidebar-menu");
let modal = document.querySelector("#te-modal");

const options = {
  attributes: true,
};

// function callback(mutationList, observer) {
//   mutationList.forEach(function (mutation) {
//     if (mutation.type === "attributes" && mutation.attributeName === "class") {
//       if (headerMain.classList[6] == "Header--shifted") {
//         sideMenu.classList.add("sideBarMenu__HeaderShifted");

//         if (modal) {
//           modal.classList.add("Header__Shifted");
//         }
//       } else {
//         sideMenu.classList.remove("sideBarMenu__HeaderShifted");

//         if (modal) {
//           modal.classList.remove("Header__Shifted");
//         }
//       }
//     }
//   });
// }

// const observer = new MutationObserver(callback);
// observer.observe(headerMain, options);

/*const optionss = {
  attributes: true
}

let chatButton;

function sidemenuOpen(mutationList, menuObserver) {
  mutationList.forEach(function(mutation) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
      var gorgiasChatInterval = window.setInterval(function() {
        if (GorgiasChat.init()) {
          window.clearInterval(gorgiasChatInterval); // this line breaks out of the loop - make sure it's not deleted.
          let chatButton = document.querySelector('#chat-button');

              if(sideMenu.attributes[2].value == "true") {
                chatButton.classList.remove('chatButtonMove');
              }
              else {
                chatButton.classList.add('chatButtonMove');
              }
        }
      }, 100)
    }
  })
}

const menuObserver = new MutationObserver(sidemenuOpen)
menuObserver.observe(sideMenu, optionss)*/

var initGorgiasChatPromise = window.GorgiasChat
  ? window.GorgiasChat.init()
  : new Promise(function (resolve) {
      window.addEventListener("gorgias-widget-loaded", function () {
        resolve();
      });
    });

// initGorgiasChatPromise.then(async () => {
//   // custom code
//   const optionss = {
//     attributes: true,
//   };

//   let chatButton;

//   function sidemenuOpen(mutationList, menuObserver) {
//     mutationList.forEach(function (mutation) {
//       if (
//         mutation.type === "attributes" &&
//         mutation.attributeName === "aria-hidden"
//       ) {
//         let chatButton = document.querySelector("#chat-button");

//         if (sideMenu.attributes[2].value == "true") {
//           chatButton.classList.remove("chatButtonMove");
//         } else {
//           chatButton.classList.add("chatButtonMove");
//         }
//       }
//     });
//   }

//   const menuObserver = new MutationObserver(sidemenuOpen);
//   menuObserver.observe(sideMenu, optionss);
// });

/* Gorgias Chat Text Changes */

/*addEventListener('DOMContentLoaded', (event) => {
  var gorgiasChatInterval = window.setInterval(function() {
    if (window.GorgiasChat && GorgiasChat.hasOwnProperty("on")) {
          window.clearInterval(gorgiasChatInterval); // this line breaks out of the loop - make sure it's not deleted.
          //console.log('GorgiasChat-ready');

          const sspTexts = {
              wasThisRelevant: 'Was deze info nuttig?',
              happyToHelp: 'Fijn dat we konden helpen. Liefs Guud Woman Team',
              sorryToHearThatOnlineEmailCaptured: 'Laat je email adres achter en stel je vraag hier. Als er geen expert beschikbaar is op de chat zal je een antwoordje via email ontvangen. Liefs Guud Woman Team',
              sorryToHearThatOfflineEmailCaptured: 'Laat je email adres achter en stel je vraag hier. Als er geen expert beschikbaar is op de chat zal je een antwoordje via email ontvangen. Liefs Guud Woman Team',
              sorryToHearThatEmailRequired: 'Laat je email adres achter en stel je vraag hier. Als er geen expert beschikbaar is op de chat zal je een antwoordje via email ontvangen. Liefs Guud Woman Team',
              sorryToHearThatEmailRequired: 'Laat je email adres achter en stel je vraag hier. Als er geen expert beschikbaar is op de chat zal je een antwoordje via email ontvangen. Liefs Guud Woman Team',
              fillYourEmailToTalkToAnAgent: 'Laat je gegevens na'
          }

          GorgiasChat.updateSSPTexts(sspTexts)
    }
  }, 100);

});*/

var initGorgiasChatPromise = window.GorgiasChat
  ? window.GorgiasChat.init()
  : new Promise(function (resolve) {
      window.addEventListener("gorgias-widget-loaded", function () {
        resolve();
      });
    });

initGorgiasChatPromise.then(async () => {
  // custom code

  const sspTexts = {
    wasThisRelevant: "Was deze info nuttig?",
    happyToHelp: "Fijn dat we konden helpen. Liefs Guud Woman Team",
    sorryToHearThatOnlineEmailCaptured:
      "Laat je email adres achter en stel je vraag hier. Als er geen expert beschikbaar is op de chat zal je een antwoordje via email ontvangen. Liefs Guud Woman Team",
    sorryToHearThatOfflineEmailCaptured:
      "Laat je email adres achter en stel je vraag hier. Als er geen expert beschikbaar is op de chat zal je een antwoordje via email ontvangen. Liefs Guud Woman Team",
    sorryToHearThatEmailRequired:
      "Laat je email adres achter en stel je vraag hier. Als er geen expert beschikbaar is op de chat zal je een antwoordje via email ontvangen. Liefs Guud Woman Team",
    sorryToHearThatEmailRequired:
      "Laat je email adres achter en stel je vraag hier. Als er geen expert beschikbaar is op de chat zal je een antwoordje via email ontvangen. Liefs Guud Woman Team",
    fillYourEmailToTalkToAnAgent: "Laat je gegevens na",
  };

  GorgiasChat.updateSSPTexts(sspTexts);
});
